// extracted by mini-css-extract-plugin
module.exports = {"container":"ChangeStepButton_container__2ofeS","img":"ChangeStepButton_img__2FEB-","text":"ChangeStepButton_text__i711o"};